export default [
  //登录页
  {
    path: "/",
    name: "main",
    meta: {
      requireAuth: false,
    },
    component: () => import("@/page/Main"),
  },
  {
    path: "/about",
    name: "about",
    meta: {
      requireAuth: false,
    },
    component: () => import("@/page/About"),
  },
  {
    path: "/sever",
    name: "sever",
    meta: {
      requireAuth: false,
    },
    component: () => import("@/page/Sever"),
  },
  {
    path: "/solution",
    name: "solution",
    meta: {
      requireAuth: false,
    },
    component: () => import("@/page/Solution"),
  },
  {
    path: "/studio",
    name: "studio",
    meta: {
      requireAuth: false,
    },
    component: () => import("@/page/Studio"),
  },
];



// WEBPACK FOOTER //
// ./src/router/index.js